export enum UserRoles {
    admin = 'admin',
    user = 'user',
    demo = 'demo',
    editor = 'editor',
}
